

export const authMiddleware = () => (next) => (action) => {

  // Check if the action is defined and has a type
  // if (action && action.type) {
  

  //   // Check if the action involves an API call and requires authentication
  //   if (action.meta && action.meta.requiresAuth) {
  //     const token = getToken();
  //     if (token) {
  //       if (!action.payload) {
  //         action.payload = {}; // Ensure action.payload is defined
  //       }
  //       if (!action.payload.headers) {
  //         action.payload.headers = {};
  //       }
  //       action.payload.headers.Authorization = `Bearer ${token}`;
  //     }
  //   }
  // } else {
  //   console.error("Received an undefined action or action without type:", action);
  // }

  return next(action);
};
